import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ITasksStatus } from '@fi-shared/fi-task-shared/fi-task-shared';

@Component({
    selector: 'fi-task-status-container',
    template: `
        <div class="fi-container fi-container-horizontal-portrait-min ExtraLightBackgroundColor">
            <div class="fi-content">
                <fi-tasks-status [tasksStatus]="tasksStatus"> </fi-tasks-status>
            </div>
        </div>
    `,
    styleUrls: ['./task-status-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TaskStatusContainerComponent {
    @Input() tasksStatus: ITasksStatus;
}
